<app-asset-transfer-entry-details></app-asset-transfer-entry-details>